"use es6";

import Autolinker from "autolinker";

const autolinker = new Autolinker({
  newWindow: true,
});

export default autolinker;
